import React, { Component } from "react";
import { Button, Icon } from "semantic-ui-react";
import { HeaderWrapper } from "./style.js";
import logo from "../../assets/img/logo/logo-white.png";
import PropTypes from "prop-types";
import { userOperations } from "../../redux/user";

export default class SRHHeader extends Component {
  render() {
    const { breadcrumbs } = this.props;
    return <HeaderWrapper>{this.props.children}</HeaderWrapper>;
  }
}



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/index.jsx